import { render, staticRenderFns } from "./DsfUserHome.vue?vue&type=template&id=b73a0d5c&"
import script from "./DsfUserHome.vue?vue&type=script&lang=js&"
export * from "./DsfUserHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b73a0d5c')) {
      api.createRecord('b73a0d5c', component.options)
    } else {
      api.reload('b73a0d5c', component.options)
    }
    module.hot.accept("./DsfUserHome.vue?vue&type=template&id=b73a0d5c&", function () {
      api.rerender('b73a0d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/DsfUserHome.vue"
export default component.exports